import { SizeXxlIcon } from './SizeXxlIcon';

/**
 * author: Austin Andrews
 * id 5E24686F-4675-4E74-93B4-DA7886270F3B
 * name size-xxl
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-xxl.svg
 * tags
 */
export const SizeExtraExtraLargeIcon = SizeXxlIcon;
export default SizeExtraExtraLargeIcon